
import "./Navbar.css";
import React, { useEffect, useState } from "react";
import config from "../Config/Config.json";

function Navbar({ ProfileDetailRef, ResumeRef, ProjectsRef, ContactRef }) {

const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const opacityValue = Math.max(1 - scrollPosition / 300, 0); // fades to 30% opacity


  return (
  <nav className="navbar"
  style={{
        opacity: opacityValue,
        transition: "opacity 0.3s ease-in-out",
      }}
  >
    
        <div className="navbar-detail" onClick={ProfileDetailRef}>
            <img className="navbar-logo" src="assets/logo.png" alt=""/>
            <div className="navbar-profile-name">{config.name}</div>
            <div className="navbar-profile-designation">{config.designation}</div>
        </div>
        <div className="navbar-links">
            <div className="navbar-profile-option" onClick={ResumeRef} >Resume</div>
            <div>|</div>
            <div className="navbar-profile-option" onClick={ProjectsRef}>Projects</div>
            <div>|</div>
            <div className="navbar-profile-option" onClick={ () => {
              window.open("https://www.behance.net/vinay_portfoilo", "_blank")
            }}>Portfolio</div>
            <div>|</div>
            <div className="navbar-profile-option" onClick={ContactRef}>Contact</div>
        </div>
    
  </nav>);
}
export default Navbar;